export default __webpack_public_path__ + "static/media/12_1.c07b835d.jpg";